import VLFTextField from "@/components/Input/TextField";

import {
	MATCH_ADVANCED_CONTEXT_SECTIONS,
	MATCH_ADVANCED_FOR_AGAINST_SECTIONS,
	MATCH_ADVANCED_SIMPLE_SECTIONS,
	FOR_AGAINST_TYPES,
	MATCH_HALVES,
	formatAdvancedStatValue,
} from "@/config/matchAdvancedStats";

import "./index.scss";

function StatsSection({title, content}) {
	return (
		<section className="advanced-stats-section" aria-label={title}>
			<header className="advanced-stats-section__header">
				<h3>{title}</h3>
			</header>
			<div className="advanced-stats-section__body">{content}</div>
		</section>
	);
}

// Card delle statistiche avanzate di squadra, condivise tra il tab del dettaglio
// partita: in lettura, oppure modificabili nel tab.
// Se viene passato `onChange(field, value)` le celle diventano editabili.
export default function AdvancedStatsCards({values, onChange}) {
	const editable = !!onChange;

	const cell = (field, metric) =>
		editable ? (
			<div key={field} className="cell">
				<VLFTextField
					type="number"
					size="small"
					margin="none"
					inputProps={{
						step:
							metric.decimals && metric.decimals > 0
								? 10 ** -metric.decimals
								: 1,
					}}
					value={values?.[field] ?? ""}
					onChange={(e) => onChange(field, e.target.value)}
					placeholder="0"
					onlyLabel
				/>
			</div>
		) : (
			<div key={field} className="cell value">
				{formatAdvancedStatValue(
					values?.[field],
					metric.decimals,
					metric.suffix,
				)}
			</div>
		);

	const forAgainstCard = (section) => (
		<StatsSection
			key={section.title}
			title={section.title}
			content={
				<div className="advanced-stats-card for-against">
					<div className="advanced-stats-row header">
						<div className="label">Statistica</div>
						{MATCH_HALVES.map((half, index) =>
							FOR_AGAINST_TYPES.map((type) => (
								<div
									key={`${section.title}-${half}-${type.suffix}`}
									className="cell"
								>
									{index === 0 ? "1T" : "2T"} {type.label}
								</div>
							)),
						)}
					</div>
					{section.metrics.map((metric) => (
						<div key={metric.key} className="advanced-stats-row">
							<div className="label">{metric.label}</div>
							{MATCH_HALVES.map((half) =>
								FOR_AGAINST_TYPES.map((type) =>
									cell(`${metric.key}${type.suffix}${half}`, metric),
								),
							)}
						</div>
					))}
				</div>
			}
		/>
	);

	const contextCard = (section) => (
		<StatsSection
			key={section.title}
			title={section.title}
			content={
				<div className="advanced-stats-card context">
					<div className="advanced-stats-row header">
						<div className="label">Statistica</div>
						{MATCH_HALVES.map((half, index) => (
							<div key={`${section.title}-half-${half}`} className="cell">
								{index === 0 ? "1° tempo" : "2° tempo"}
							</div>
						))}
					</div>
					{section.metrics.map((metric) => (
						<div key={metric.key} className="context-group">
							<div className="group-title">{metric.label}</div>
							{metric.contexts.map((context) => (
								<div
									key={`${metric.key}-${context.suffix}`}
									className="advanced-stats-row"
								>
									<div className="label">{context.label}</div>
									{MATCH_HALVES.map((half) =>
										cell(`${metric.key}${context.suffix}${half}`, metric),
									)}
								</div>
							))}
						</div>
					))}
				</div>
			}
		/>
	);

	const simpleCard = (section) => (
		<StatsSection
			key={section.title}
			title={section.title}
			content={
				<div className="advanced-stats-card simple">
					<div className="advanced-stats-row header">
						<div className="label">Statistica</div>
						{MATCH_HALVES.map((half, index) => (
							<div key={`${section.title}-simple-${half}`} className="cell">
								{index === 0 ? "1° tempo" : "2° tempo"}
							</div>
						))}
					</div>
					{section.metrics.map((metric) => (
						<div key={metric.key} className="advanced-stats-row">
							<div className="label">{metric.label}</div>
							{MATCH_HALVES.map((half) => cell(`${metric.key}${half}`, metric))}
						</div>
					))}
				</div>
			}
		/>
	);

	return (
		<>
			<div className="col-sm-12 padding-small">
				<div className="advanced-section-title">A favore e contro</div>
				<div className="advanced-section-grid">
					{MATCH_ADVANCED_FOR_AGAINST_SECTIONS.map(forAgainstCard)}
				</div>
			</div>
			<div className="col-sm-12 padding-small">
				<div className="advanced-section-title">Perdite e possesso</div>
				<div className="advanced-section-grid">
					{MATCH_ADVANCED_CONTEXT_SECTIONS.map(contextCard)}
				</div>
			</div>
			<div className="col-sm-12 padding-small">
				<div className="advanced-section-title">
					Statistiche squadra e portiere
				</div>
				<div className="advanced-section-grid">
					{MATCH_ADVANCED_SIMPLE_SECTIONS.map(simpleCard)}
				</div>
			</div>
		</>
	);
}
